import _ from 'lodash'
export default function ProcessAllTabs (data) {
  // Todo cada uno de los datos debe ser parseado.
  let array = []
  _(data).forEach((d) => {
    let tmp = {
      _id: d['_id'],
      presionSentadoBaja: d['diastoleSentado'],
      presionParadoBaja: d['diastoleParado'],
      presionSentadoAlta: d['sistoleSentado'],
      presionParadoAlta: d['sistoleParado'],
      perimetroAbdominal: d['perimetroAbdominal'],
      balanceNeuroMuscular: d['balanceNeuroMuscularIzquierdo'],
      balanceNeuroMuscularD: d['balanceNeuroMuscularDerecho'],
      balanceNeuroIMuscular: d['balanceNeuroMuscularIzquierdo'],
      balanceNeuroDMuscular: d['balanceNeuroMuscularDerecho'],
      itbIzquierdo: d['itbIzquierdo'],
      itbDerecho: d['itbDerecho'],
      itbi: d['itbIzquierdo'],
      itbd: d['itbDerecho'],
      fuma: d['fuma'],
      imc: d['imc'],
      vop: d['vop'],
      observaciones: d['notas'],
      notasText: d['notas'],
      frecuencia: d['frecuencia'],
      tiempoCincoM: d['tiempoCincoM'],
      patientGender: d['gender'],
      peso: d['peso'], altura: d['altura'],
      patientBirthday: d['fechaNacimiento'],
      health: d['salud'],
      temperatura: d['temperatura'],
      patientId: d['paciente'],
      mets: d.mets,
      depresion: d.depresion,
      satisfaccion: d.satisfaccion,
      feliz: d.feliz,
      preocupacion: d.preocupacion,
      decaido: d.decaido,
      movilidad: d.movilidad,
      cuidadoPersonal: d.cuidadoPersonal,
      actividadesCotidianas: d.actividadesCotidianas,
      dolor: d.dolor,
      ansiedad: d.ansiedad
    }
    tmp.medicalData = tmp
    array.push(tmp)
  })
  return array
}
/*
actividadesCotidianas: 2
altura: 150
ansiedad: 1
balanceNeuroMuscularDerecho: 30
balanceNeuroMuscularIzquierdo: 30
balanceNeuroMuscularT: 30
cuidadoPersonal: 1
decaido: 6
depresion: 9
diastoleParado: 80
diastoleSentado: 60
dolor: 2
fechaDeTomaDeDatos: "2019-04-15T21:50:04.240Z"
fechaNacimiento: "1956-11-05T05:00:00.000Z"
feliz: 7
frecuencia: 60
fuma: "No"
gender: "m"
imc: 26.666666666666668
itbDerecho: 1
itbIzquierdo: 1
mets: 2
movilidad: 3
notas: "sin nota"
paciente: "5c51e60fadd425634ecad879"
perimetroAbdominal: 50
peso: 60
preocupacion: 7
salud: 24
satisfaccion: 3
sistoleParado: 180
sistoleSentado: 170
temperatura: 34
tiempoCincoM: 2
timeUpdate: "1555365004241"
timestamp: "1555365004241"
usuarioCreacion: "57894d2c8c7151d21028dbd3"
usuarioUltimaModificacion: "57894d2c8c7151d21028dbd3"
versionAlgoritmo: "v1"
vop: 4 */


// WEBPACK FOOTER //
// ./src/components/Health/ProcessAllTabs.js